import React from "react";
import { useFormContext } from "react-hook-form";
import SurveyFormField from "../../../../shared/components/surveyFormField/SurveyFormField";

const NameForm = ({ isDisabled }) => {
  const {
    formState: { errors },
  } = useFormContext();

  return (
    <div>
      <div className="question-heading">What is your name?</div>
      <div className="form-fields">
        <SurveyFormField
          name="name"
          placeHolder="First Name"
          isDisabled={isDisabled}
        />
        {errors.name && <div className="error">{errors.name.message}</div>}
      </div>
      <div className="form-fields mt-3">
        <SurveyFormField
          name="lastName"
          placeHolder="Last Name"
          isDisabled={isDisabled}
        />
        {errors.lastName && (
          <div className="error">{errors.lastName.message}</div>
        )}
      </div>
    </div>
  );
};

export default NameForm;
